import { Component, Input, Output, EventEmitter, ElementRef, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core'

@Component({
    selector: 'card-thumbnail',
    templateUrl: './renderCardThumbnail.component.html',
    styleUrls: ['./renderCardThumbnail.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class RenderCardThumbnail {

    @Input() data: any;

    @Output() clickEvent: EventEmitter<any> = new EventEmitter();

    @ViewChild('chatMessageActions', {static: true}) chatMessageActions;

    constructor(
        private _El: ElementRef,
        private _R: Renderer2
    ) { }

    ngOnInit() {
        // start entry animation
        this.animationStart();
    }

    ngAfterViewInit() {
        // check if parent msg is your self
        this.checkParent();
    }

    /**
     * confere se o elemento anterior é do tipo texto enviado pelo bot
     *
     * centralizar no futuro
     */
    checkParent() {
        let parent = this._El.nativeElement.previousElementSibling;

        if (parent && parent.tagName == "PLAIN-TEXT") {
            if (parent.firstChild.classList.contains("chat-message--left")) {
                this._R.addClass(this.chatMessageActions.nativeElement, 'text-sequence');
            }
        }
    }

    animationStart() {
        // animacao de entrada do elemento
        setTimeout(() => {
            this._R.addClass(this.chatMessageActions.nativeElement, 'on-entry');
        }, 1000);

        // animacao de entrada dos botons
        setTimeout(() => {
            this._R.addClass(this.chatMessageActions.nativeElement, 'options-enter');
        }, 1200);
    }

    /**
     * Recebe um click e emite um evento com esse valor para o elemento pai (message.component)
     *
     * @param value valor da mensagem clicada
     */
    messageClicked(value) {
        this.clickEvent.emit({
            event: event,
            value: value
        });
        this._R.addClass(event.target, 'active');
        this.disableButtons();
    }

    /**
     * Desabilita todos os botons, exeto o clicado
     */
    disableButtons() {
        let buttons = Array.from(this._El.nativeElement.querySelectorAll('.chat-message-actions-btn:not(.active)'));

        buttons.map((el, idx) => {
            this._R.addClass(el, 'disabled');
        });
    }
}
